import axiosClient from "../../../../system/helpers/axiosConfig";

export const getReport = (api, params) => {
  return axiosClient.post(api, params).then((r) => r.data);
};
